enum LANGUAGE {
  VI = "vi",
  EN = "en",
  KO = "ko",
}

export default LANGUAGE;
